import React from 'react';
import styles from './Navbar.module.css'; // Import the styles object
import logo from '../../assets/images/logo.png'
import { Link, useNavigate } from 'react-router-dom';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const Navbar = (props) => {
    const navBarOptions = props.navBarOptions;
    const navigate = useNavigate();

    return (
        <nav className={styles.navbar}>
            <div className={styles.navbarLeft}>
                <a href="/">
                    {/* Accessing nested logo class */}
                    <img src={logo} className={styles.logo} alt="logo" />
                </a>
            </div>
            <div className={styles.navbarCenter}>
                <ul className={styles.navLinks}>
                    {navBarOptions.map((option, index) => {
                        return (
                            <li key={option.text} className={styles.navItem}>
                                <Link to={option.href || "#"} onClick={(e) => {
                                    if (option.href) navigate(option.href);
                                    if (!option.href) e.preventDefault();
                                }}>
                                    {option.text}{option?.children && <ArrowDropDownIcon/>}
                                </Link>
                                
                                {option.children && (
                                    <ul className={styles.dropdown}>
                                        {option.children.map((child) => (
                                            <li key={child.href}>
                                                <Link to={child.href} onClick={() => navigate(child.href)}>
                                                    {child.text}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </div>
            { props.user &&
            <div className={styles.navbarRight}>
                <Link onClick={props.handleLogout}>
                    <span>Log Out</span>
                </Link>
            </div>
            }
        </nav>
    );
};

export default Navbar;